var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBurst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1118.6 814.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st2, .st3 {\n        isolation: isolate;\n      }\n\n      .st3 {\n        mix-blend-mode: overlay;\n        opacity: .5;\n      }\n\n      .st4 {\n        fill: #50c9f1;\n      }\n\n      .st5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 0.2,
    y: 4.5,
    width: 1105.1,
    height: 806.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 13.2,
    y: 0.5,
    width: 1105.1,
    height: 813.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1069.4 424.8 954.8 331.5 1002.8 193.8 859.6 186.9 820 45.7 703.7 126.2 631.2 34.8 564.8 115.2 505.4 45.6 413.2 114.8 304.3 47.1 257.6 183.9 114.4 176 155.2 318.4 36.2 399.5 150.8 492.8 102.7 630.5 245.9 637.4 285.5 778.6 401.9 698.1 483 804.5 563.2 694.2 612.4 757.3 689.3 684.9 801.2 777.2 847.9 640.4 991.2 648.3 950.3 505.9 1069.4 424.8"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1082.4 424.5 967.8 330.4 1015.8 191.4 872.6 184.5 833 42 716.7 123.2 644.2 31 577.8 112.1 518.4 41.9 426.2 111.8 289.9 68.1 270.6 181.4 127.4 173.5 168.2 317.1 49.2 399 163.8 493 115.7 632 258.9 639 298.5 781.5 414.9 700.2 496 807.6 576.2 696.3 625.4 759.9 702.3 686.9 814.2 780 860.9 642 1004.2 650 963.3 506.4 1082.4 424.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,808.4l-.4-.5-80.9-107-116.5,81.3-.2-.7-39.5-142.1-143.6-7,48.2-139.3-114.8-94.2,119.3-82.1-40.9-144,143.5,8,19.3-113.5,136.6,43.8,92.4-70,59.3,70.1,66.4-81.1.4.5,72.2,91.9,116.5-81.4.2.7,39.5,142.1,143.5,7-.2.6-47.9,138.7,114.8,94.2-119.3,82.1,41,144h-.7s-142.8-8-142.8-8l-46.8,138.3-.6-.5-111.6-92.8-77,73.1-49.1-63.5-80.2,111.3ZM415,699.5l.3.4,80.8,106.8,80.2-111.3.4.5,48.8,63.2,76.9-72.9.3.3,111.3,92.6,46.6-137.6h.4s142.5,7.9,142.5,7.9l-40.8-143.3.3-.2,118.5-81.5-114.3-93.8v-.3c.1,0,48-138.4,48-138.4l-142.9-6.9-39.5-142.1-116.2,81.1-72.4-92.1-66.4,81.1-.4-.5-59.1-69.8-92,69.7h-.2c0,0-135.8-43.6-135.8-43.6l-19.2,113.2h-.4s-142.5-7.9-142.5-7.9l40.8,143.3-118.8,81.7,114.3,93.8-48,138.7,142.9,6.9v.3c0,0,39.5,141.8,39.5,141.8l116.2-81.1Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBurst);
export default __webpack_public_path__ + "static/media/blue-burst.fe823cd0c38a15a81b76dd10aca5503f.svg";
export { ForwardRef as ReactComponent };